import { Component, OnInit, HostListener, ɵConsole, OnDestroy } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { Router, NavigationExtras } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { ConfirmDialogModel, ConfirmationDialogComponent } from 'src/app/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material';
import { environment } from 'src/environments/environment';
import { takeUntil, debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';

@Component({
  selector: 'app-epc-users',
  templateUrl: './epc-users.component.html',
  styleUrls: ['./epc-users.component.scss']
})
export class EpcUsersComponent implements OnInit ,OnDestroy {

  public baseURL = environment.apiBase;
  private searchEpcUsersSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  private ResponseVerifiedGetAllEpcUser$: Subject<any> = new Subject();
  private ResponseVerifiedChangePassword$: Subject<any> = new Subject();
  private ResponseVerifiedChangeEpcStatus$: Subject<any> = new Subject();

  closeResult: string;
  public adminEpcUserList: any;
  dataObject: any = {};
  role: any;
  roleName: string;
  search: any = '';
  page = 1;
  limit: any = 10;
  offset: any = 0;
  selectedUserId: any;
  editEpcResquestObject: any = {};
  userChangePasswordRequestObject: any = {};
  count: any;
  SadminAccess: any = [];
  access: any;
  // checked = false;
  constructor(private dashboardService: DashboardService, private modalService1: NgbModal, private router: Router,
    private toastr: ToastrService, private dialog: MatDialog,) {
    this.role = localStorage.role;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    } {
      this.roleName = 'slave_admin';
    }
  }

  ngOnInit() {
    this.SadminAccess = JSON.parse(localStorage.getItem('SadminAccess') || '[]');

    if (localStorage.SadminAccess != undefined) {
      this.SadminAccess.forEach(x => {
        if (x.menu_name == 'User Registration') {
          this.access = x.access;
        }
      });
    }
    if (this.roleName == 'admin' || this.roleName == 'slave_admin') {
      this.getAllEpcUser(this.search, this.limit, this.offset);
      this.searchAllEpcUsers();
    }

  }

  // get alladmin epc user list

  getAllEpcUser(search, limit, offset) {
    if (offset == 0) {
      this.page = 1;
    }
    this.dataObject = {
      search: search,
      limit: limit,
      offset: offset
    };
    this.dashboardService.getAllEpcUser(this.dataObject)
      .pipe(takeUntil(this.ResponseVerifiedGetAllEpcUser$))
      .subscribe(
        async data => {
          this.adminEpcUserList = [];
          this.count = 0;
          if (data.status) {
            this.count = data.count;
            this.adminEpcUserList = data.resultObject;

          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(['/login']);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  searchAllEpcUsers() {
    this.searchEpcUsersSubject.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      takeUntil(this.destroy$),
      tap(searchValue => {
        this.search = searchValue;
        this.getAllEpcUser(this.search, 10, 0);
      })
    ).subscribe();
  }

  onSearchEpcUsers(event: KeyboardEvent) {
    this.searchEpcUsersSubject.next((event.target as HTMLInputElement).value.trim() || "");
  }

  editEpc(userId) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        'id': userId,
      }
    };
    this.router.navigate(['/inject-solar/add-epc/'], navigationExtras);
  }

  // change password modal start
  openResetPasswordDialog(content, id) {
    this.selectedUserId = id;
    this.modalService1.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  onUpdate(formData) {
    this.userChangePasswordRequestObject = {
      epc_id: this.selectedUserId,
      new_password: formData.value.newPassword,
      confirm_password: formData.value.confirmPassword
    };
    this.changePasswordByUserId(this.userChangePasswordRequestObject);
  }

  // change password by userid
  changePasswordByUserId(userChangePasswordRequestObject) {

    this.dashboardService
      .changePasswordByUserIdAdmin(userChangePasswordRequestObject)
      .pipe(takeUntil(this.ResponseVerifiedChangePassword$))
      .subscribe(
        async data => {
          if (data.status) {
            this.toastr.success('Password Changed Successfully!!');
            this.modalService1.dismissAll();
            this.getAllEpcUser(this.search, this.limit, this.offset);


          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  nextPageNew(pageIndex): void {

    this.offset = (pageIndex - 1) * 10;
    this.page = pageIndex;
    this.getAllEpcUser(this.search, this.limit, this.offset);

  }

  //change status of epc

  changeEpcStatus(epcId, is_active, index) {

    if (is_active === '1') {
      this.adminEpcUserList[index].is_active = '0';
    } else {
      this.adminEpcUserList[index].is_active = '1';
    }
    this.editEpcResquestObject = {
      epc_id: epcId,
      is_active: this.adminEpcUserList[index].is_active
    };
    this.dashboardService.enableDisableEpcStatusById(this.editEpcResquestObject)
      .pipe(takeUntil(this.ResponseVerifiedChangeEpcStatus$))
      .subscribe(
        async data => {
          if (data.status) {
            this.getAllEpcUser(this.search, this.limit, this.offset);
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  public confirmDialog(id: any): void {
    let message = "Are you sure you want to delete this User?";
    let title = "Confirm Action";
    const dialogData = new ConfirmDialogModel(title, message);
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteEpcuserByUserId(id);
      }
    });
  }
  deleteEpcuserByUserId(id) {
    var UserIdObj = {
      epc_id: id,
    };
    this.dashboardService.deleteEpcUserByEpc(UserIdObj)
      .pipe(takeUntil(this.ResponseVerifiedGetAllEpcUser$))
      .subscribe(
        async data => {
          if (data.status) {
            this.toastr.success(data.message);
            this.getAllEpcUser(this.search, this.limit, this.offset);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);
            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  ngOnDestroy() {
    this.ResponseVerifiedGetAllEpcUser$.next();
    this.ResponseVerifiedGetAllEpcUser$.complete();
    this.ResponseVerifiedChangePassword$.next();
    this.ResponseVerifiedChangePassword$.complete();
    this.ResponseVerifiedChangeEpcStatus$.next();
    this.ResponseVerifiedChangeEpcStatus$.complete();
    this.destroy$.next();
    this.destroy$.complete();
    this.searchEpcUsersSubject.next();
    this.searchEpcUsersSubject.complete();
  }
}



